import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "../components/ui/button";
import { useI18n } from "../config/i18n";
export function LanguageToggle() {
    const { lang, setLang } = useI18n();
    return (_jsx(Button, { onClick: () => setLang(lang === "it" ? "en" : "it"), "aria-label": "Change language", style: {
            position: "absolute",
            top: 0,
            right: 0,
            zIndex: 100,
            padding: "20px",
            borderRadius: 0,
            color: "#464545",
            background: "#ffffff96",
        }, children: lang === "it" ? "IT" : "EN" }));
}
